import greenLocation from '@/assets/img/location-green.png'
import redLocation from '@/assets/img/location-red.png'
import yellowLocation from '@/assets/img/location-yellow.png'
import trafficLightIcon from '@/assets/img/iconTraficLight.png'
import detectorIcon from '@/assets/img/icons/detector.png'
import rhombusIcon from '@/assets/img/rhombus.png'
import { DeviceType } from '@/types/enums'
import { useActions } from '@/hooks'
import ymaps from 'yandex-maps'
import {
  UnitsMapTypeRes,
  UnitsMapType,
} from '@/modules/maps-tank/types/unitsMapType'
import {
  Map,
  Placemark,
  SearchControl,
  TypeSelector,
  ZoomControl,
} from '@pbe/react-yandex-maps'
import React, { FC, memo, useRef } from 'react'
import MyPolyLine from '@/modules/maps/components/PolyLine'
import MapCircle from '@/modules/maps/components/Circle'

interface Props {
  center: number[]
  setNewCoords: (coords: number[]) => void
  dataUnits: UnitsMapTypeRes | undefined
  newCoords: number[]
  draggable: boolean
}

export const getIconForUnit = (unit: UnitsMapType): string => {
  let res = greenLocation
  const { state, typeId } = unit
  if (state === 1) res = greenLocation
  if (state === 2) res = yellowLocation
  if (state === 3) res = redLocation
  if (typeId === DeviceType.kao || typeId === DeviceType.ksodd)
    res = rhombusIcon
  if (typeId === DeviceType.trafficLight) res = trafficLightIcon
  if (typeId === DeviceType.detector) res = detectorIcon
  return res
}

const MapFeatures: FC<Props> = ({
  center,
  setNewCoords,
  dataUnits,
  newCoords,
  draggable,
}) => {
  const { setIsChangeFeatures } = useActions()
  const yMap = useRef<any>()
  const refPlacemark = useRef<any>(null)
  const handleMapClick = (event: any) => {
    const clickedCoords = event.get('coords')
    setNewCoords(clickedCoords)
    setIsChangeFeatures(true)
  }

  const handlePlacemarkDragEnd = () => {
    const draggedCoords = refPlacemark.current.geometry?._coordinates
    if (draggedCoords) {
      setNewCoords(draggedCoords)
      setIsChangeFeatures(true)
    }
  }

  const getLightsLocations = dataUnits?.data?.data.filter(
    (item) => item.typeId === DeviceType.lightning
  )

  const clusters = dataUnits?.data?.data.filter(
    (item) =>
      item.typeId === DeviceType.dtpYellow || item.typeId === DeviceType.dtpRed
  )

  const unitsWithoutDtp = dataUnits?.data?.data.filter(
    (item) =>
      item.typeId !== DeviceType.lightning &&
      // item.typeId !== DeviceType.dtp &&
      item.typeId !== DeviceType.dtpYellow &&
      item.typeId !== DeviceType.dtpRed
  )

  return (
    <Map
      instanceRef={yMap}
      state={{ center, zoom: 9, controls: [] }}
      options={{ yandexMapDisablePoiInteractivity: true }}
      modules={['control.ZoomControl']}
      width='100%'
      height='100%'
      onClick={handleMapClick}
    >
      <SearchControl options={{ float: 'left', noPlacemark: true }} />
      <ZoomControl
        options={{
          position: {
            right: 10,
            left: 'auto',
            top: (document.documentElement.scrollHeight - 530) / 2,
            bottom: 'auto',
          },
          // @ts-ignore
          float: 'right',
        }}
      />

      <TypeSelector
        options={{
          // @ts-ignore
          panoramasItemMode: 'off',
        }}
      />
      {getLightsLocations?.map((unit, i) => {
        return (
          <MyPolyLine
            key={unit.id}
            // @ts-ignore
            unit={unit}
          />
        )
      })}
      {clusters?.map((unit) => (
        <MapCircle
          key={unit.id}
          unit={unit}
          zoomState={9}
          yMap={yMap}
        />
      ))}
      {unitsWithoutDtp?.map((unit) => (
        <Placemark
          key={unit.id}
          defaultGeometry={unit.coordinates}
          options={{
            iconLayout: 'default#image',
            iconImageSize: [30, 30],
            iconImageHref: getIconForUnit(unit),
          }}
        />
      ))}
      <Placemark
        instanceRef={refPlacemark}
        onDragEnd={handlePlacemarkDragEnd}
        geometry={newCoords}
        options={{
          iconImageSize: [30, 30],
          draggable,
          preset: 'islands#greenIcon',
        }}
        properties={{ iconContent: '+' }}
      />
    </Map>
  )
}

export default memo(MapFeatures)
